/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react'
import _ from 'lodash'
import { colors } from '@lmc/common/constants'
import { getJSON } from '../../../common/services/api'
import { ProfileLink } from '../../../components/generic'
import { Link } from 'react-router-dom'
import { Button, Icon } from '@lmc/ui-kit'
import { CardTitle } from './CardComponents'
import styled from 'styled-components'

const TITLE = 'Family App'

type Profile = any

type Data = {
  result: {
    activeAccounts: any
    seenRecently: unknown[]
    invited: boolean
  }
}

type Response = {
  data: Data
}

const getBodyText = (seenRecently: number, invited: boolean) => {
  if (!invited)
    return <p>You`re all set up, but no family members have been invited yet</p>
  if (!seenRecently)
    return (
      <p>
        It doesn’t look like any family members have been active recently (last
        24 hrs)
      </p>
    )
  if (seenRecently === 1) {
    return (
      <p>
        <strong>One family member</strong> has been active recently (last 24h)
      </p>
    )
  }
  return (
    <p>
      <strong>{seenRecently} family members</strong> have been active recently
      (last 24h)
    </p>
  )
}

const Body = ({ data }: Response) => {
  const [nShowing, showMore] = useState(10)
  if (!data) return null
  return (
    <div>
      <p>
        Active <StyledCount>({data?.result?.activeAccounts || 0})</StyledCount>
        Sent Invite <StyledCount>({data?.result?.invited || 0})</StyledCount>
      </p>
      {getBodyText(data?.result?.seenRecently?.length, data?.result?.invited)}
      <div className="lmc-flex-grid">
        {_.take(data?.result?.seenRecently || [], nShowing).map(
          (profile: Profile) => (
            <ProfileLink
              key={profile.id}
              list="residents"
              id={profile.resident}
              name={profile.name}
              picture={profile.picture}
            />
          )
        )}
        {data?.result?.seenRecently?.length > nShowing ? (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a className="lmc-more-link" onClick={() => showMore(nShowing + 30)}>
            More...
          </a>
        ) : null}
      </div>
    </div>
  )
}

const Footer = () => (
  <div className="lmc-home-card-footer">
    <StyledFooter>
      <div />
      <Link to="/settings/family-invite">
        <Button variant="primary" icon={<Icon name="MailOutlined" />}>
          Invite a Family Member
        </Button>
      </Link>
    </StyledFooter>
  </div>
)

const FamilyCard = () => {
  const [data, setData] = useState()

  useEffect(() => {
    getJSON({ url: `/api/list/carers/family-status` }).then(setData)
  }, [])

  return (
    <div>
      <StyledCard className="lmc-home-card">
        <CardTitle title={TITLE} />
        <div className="lmc-home-card-body-ss">
          <Body data={data as unknown as Data} />
        </div>
        <Footer />
      </StyledCard>
    </div>
  )
}

const StyledCard = styled.div`
  overflow: hidden;
`

const StyledFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`

const StyledCount = styled.span`
  margin-right: 12px;
  color: ${colors.darkgrey};
`

export default FamilyCard
